import { supabaseWithoutCSRF } from "../../supabaseClient";
import { signupSheetFileName } from "../../utility/signupSheets";

const downloadBlob = (blob, fileName) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export const downloadSignupSheetPdf = async ({
  tournamentId,
  eventId,
  eventIds,
  eventName,
  tournamentName,
  pageCount,
  pageCounts,
  doublesSingles,
}) => {
  const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
  const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
  const { data: sessionData } = await supabaseWithoutCSRF.auth.getSession();
  const accessToken = sessionData?.session?.access_token;
  if (!supabaseUrl || !supabaseAnonKey || !accessToken) {
    throw new Error("You need to be signed in to print signup sheets.");
  }

  const ids = (Array.isArray(eventIds) && eventIds.length
    ? eventIds
    : eventId
      ? [eventId]
      : []
  ).filter(Boolean);

  const response = await fetch(
    `${supabaseUrl}/functions/v1/generate-signup-sheets`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
        apikey: supabaseAnonKey,
      },
      body: JSON.stringify({
        tournamentId,
        eventIds: ids,
        eventId: ids[0],
        pageCount,
        pageCounts,
        doublesSingles,
      }),
    }
  );

  if (!response.ok) {
    let message = "Could not create the signup sheet.";
    try {
      const payload = await response.json();
      if (payload?.error) message = payload.error;
    } catch {
      message = (await response.text()) || message;
    }
    throw new Error(message);
  }

  const blob = await response.blob();
  downloadBlob(
    blob,
    signupSheetFileName({
      tournamentName,
      eventName,
      multiple: ids.length > 1,
    })
  );
};
